module.exports = __webpack_public_path__ + "static/media/M1-23-Ertus-Árvore-da-Cura-cod132.163f44d0.png";